import React from 'react';
import { noop } from 'lodash';

import { CategoryLayout } from 'js/components/Charts/CategoryLayout';
import { scaleLinear } from '@visx/scale';
import QuestionSetDifferential from './QuestionSetDifferential';
import ArrowMarker from '../Differential/ArrowMarker';
import { DEFAULT_STALE_DATA_MAX_AGE_MS, isStale } from './utils';

import styles from './AssessmentDifferential.module.scss';

const yScale = scaleLinear({ domain: [0, 1], range: [100, 0] });

export const QuestionSetDifferentialChart = ({
  assessments,
  showStale = false,
  staleAge = DEFAULT_STALE_DATA_MAX_AGE_MS,
  categoryLookups,
  summaryMetrics,
  renderHeaderActions,
}) => {
  const [before, after] = assessments;

  return (
    <CategoryLayout
      categoryLookups={categoryLookups}
      categories={summaryMetrics?.categories}
      stickyCategories
      fullNameBar={false}
      questionSets={summaryMetrics?.questionSets}
      renderQuestionSetName={noop}
      renderHeaderActions={renderHeaderActions}
      renderQuestionSet={(questionSet, palette) => {
        const beforeQuestionSet =
          before?.questionSets?.[questionSet.key] ?? null;
        const afterQuestionSet = after?.questionSets?.[questionSet.key] ?? null;

        const isStaleAfter =
          showStale &&
          isStale(afterQuestionSet?.insertedAt, after?.insertedAt, staleAge);
        const isStaleBefore =
          showStale &&
          isStale(beforeQuestionSet?.insertedAt, before?.insertedAt, staleAge);

        return (
          <div key={questionSet.key} className={styles['differential-item']}>
            <div className={palette} />
            <svg width={80} height={120}>
              <defs>
                <ArrowMarker id="arrow" />
              </defs>
              <g transform={`translate(0, 10)`}>
                <QuestionSetDifferential
                  from={beforeQuestionSet}
                  isStaleFrom={isStaleBefore}
                  to={afterQuestionSet}
                  isStaleTo={isStaleAfter}
                  arrowId={'arrow'}
                  yScale={yScale}
                />
              </g>
            </svg>
            <p className={styles['item-label']}>{questionSet.displayName}</p>
          </div>
        );
      }}
    />
  );
};

export default QuestionSetDifferentialChart;
